module.exports = __webpack_public_path__ + "static/media/fabLabFQFest.cb4abe09.jpg";